import React from 'react';
import IntegrationTable from '../../../../components/AdobeIoIntegrations/IntegrationTable';
import { useContentfulContext } from '../../../../contexts/ContentfulContext';

const AdobeIO = () => {
  const { content } = useContentfulContext();

  return (
    <main id="main" className="stride-page-shell flex flex-col space-y-6">
      <div>
        <span className="stride-eyebrow">Setup / Integrations</span>
        <h1 className="text-2xl font-bold tracking-tight text-stride-heading">
          {content.AdobeIO_CONTENT.title}
        </h1>
        <p className="text-sm text-stride-muted mt-1">
          {content.AdobeIO_CONTENT.description}
        </p>
      </div>
      <div className="w-full">
        <IntegrationTable />
      </div>
    </main>
  );
};

export default AdobeIO;
